import React from 'react';
import ShopTheProject from '@digital-retail/shop-the-project';
import PropTypes from 'prop-types';
import styles from './ShopTheProject.styles';
import { withProduct } from '../../utils/ProductContext';
import { withCart } from '../../utils/CartContext';
import { withApplicationContext } from '../../utils/ApplicationContext';
import { useShopTheProject } from './ShopTheProjectHook';

const ShopTheProjectWrapper = ({ activeImageIndex, mainProductImage, appCtx, product, cart }) => {
  const {
    initialPrimaryProducts,
    minComplementaryProducts,
    labels,
    showCoachmark,
    maxComplementaryProducts,
    mainProduct,
    handleAddToCart,
    getSecondaryProducts,
    analytics,
  } = useShopTheProject({
    activeImageIndex,
    mainProductImage,
    appCtx,
    product,
    cart,
  });
  if (initialPrimaryProducts.length < minComplementaryProducts) return null;
  return (
    <>
      <style jsx>{styles}</style>
      <div className="shop-the-project-container" data-testid="shop-the-project-container">
        <ShopTheProject
          labels={labels}
          initialShowCoachmark={showCoachmark}
          initialPrimaryProducts={initialPrimaryProducts.slice(0, maxComplementaryProducts)}
          mainProduct={mainProduct}
          addToCart={handleAddToCart}
          getSecondaryProducts={getSecondaryProducts}
          deviceType={appCtx.deviceType}
          analytics={analytics}
        />
      </div>
    </>
  );
};

ShopTheProjectWrapper.propTypes = {
  activeImageIndex: PropTypes.number.isRequired,
  mainProductImage: PropTypes.string.isRequired,
  appCtx: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
};

export { ShopTheProjectWrapper };
export default withProduct(withApplicationContext(withCart(ShopTheProjectWrapper)));
